import { Empty, Pagination, Row, Spin, Table } from 'antd';
import './index.scss';
import { Key, useEffect, useRef } from 'react';
import { ColumnType } from 'antd/es/table';
import { TablePaginationConfig } from 'antd/lib';

export interface IScrollTable {
  x?: number | string;
  y?: number | string;
}
type RowKey<T> = string | ((record: T, index?: number) => Key);
export interface ITableWrapProps<T> {
  className?: string;
  data?: T[];
  isLoading?: boolean;
  page?: number;
  size?: number;
  total?: number;
  children?: any;
  rowKey?: RowKey<T>;
  setSize?: (size: number) => void;
  setPage?: (page: number) => void;
  isScroll?: boolean;
  scrollValue?: IScrollTable;
  columns?: ColumnType<T>[];
  rowHoverable?: boolean;
  pagination?: false | TablePaginationConfig;
  rowClassName?: any;
}

function TableWrap<T extends object>(props: ITableWrapProps<T>) {
  const tableContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const tableBody = tableContainerRef.current?.querySelector('.ant-table-body');
      if (tableBody) {
        const { scrollTop, scrollHeight, clientHeight } = tableBody;

        if (
          scrollTop + clientHeight >= scrollHeight - 10 &&
          !props.isLoading &&
          props.page &&
          props.size &&
          props.total &&
          props.page * props.size < props.total
        ) {
          props.setPage?.(props.page + 1);
        }
      }
    };

    const tableBody = tableContainerRef.current?.querySelector('.ant-table-body');
    if (tableBody) {
      tableBody.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (tableBody) {
        tableBody.removeEventListener('scroll', handleScroll);
      }
    };
  }, [props.isLoading, props.page, props.size, props.total, props.data]);

  return (
    <div ref={tableContainerRef}>
      <Table
        className={`ebay__scroll-bar-custom ant-custom-table ${props?.className ?? ''}`}
        dataSource={props.data}
        loading={props.isLoading}
        pagination={props.pagination || false}
        columns={props.columns}
        rowKey={props.rowKey}
        rowClassName={
          props?.rowClassName ? props?.rowClassName : (record, index) => (index % 2 === 0 ? 'even-row' : 'odd-row')
        }
        locale={{
          emptyText: (
            <div
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <Empty description="データがありません" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
          ),
        }}
        scroll={props.isScroll ? props.scrollValue : {}}
        rowHoverable={props.rowHoverable}
      >
        {props.children}
      </Table>
    </div>
  );
}

export default TableWrap;
